import { Placement } from "@floating-ui/react"
import { useTransactionInfo } from "@usher/pe-client-front-end-lib"
import { PropsWithChildren } from "react"
import { TransactionInfoBase } from "./TransactionInfoBase"

export const CardTransactionInfo = ({
  transaction,
  children,
  placement,
  id,
}: {
  transaction: string
  id: string
  placement?: Placement
} & PropsWithChildren) => {
  const { fetch, data: info, loading } = useTransactionInfo(id)
  return (
    <TransactionInfoBase placement={placement} info={info} isLoading={loading} title={transaction} onOpen={() => fetch(id)}>
      {children}
    </TransactionInfoBase>
  )
}
